var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPyram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.011 71.163l60.917 105.497H189.104l60.907-105.497zM98.746 333.155l60.748 105.233H38.001l60.745-105.233zM401.275 333.155c20.408 35.349 40.43 70.036 60.725 105.19H340.561l60.714-105.19zM189.235 438.43c20.374-35.287 40.388-69.953 60.733-105.188 20.383 35.302 40.432 70.026 60.732 105.188H189.235zM189.222 193.807h121.481c-20.283 35.137-40.336 69.875-60.733 105.213l-60.748-105.213zM264.949 307.287l60.699-105.119 60.688 105.119H264.949zM325.604 430.023c-20.439-35.398-40.402-69.979-60.631-105.014h121.252c-20.19 34.971-40.155 69.557-60.621 105.014zM235.007 307.329H113.663l60.671-105.088 60.673 105.088zM113.753 324.944h121.242l-60.61 104.995a2321292.5 2321292.5 0 00-60.632-104.995z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPyram);
export default __webpack_public_path__ + "static/media/pyram.00cb2987aded841e162ca4ed98f4e208.svg";
export { ForwardRef as ReactComponent };